// this function returns Farenheit from Celsius
const toF = (input: number) => {
  return ((input * 9) / 5 + 32).toFixed(1);
};

export default toF;
